<script>
export default {
  props: {
    url: {
      type: String,
      default: null,
    },
  },
};
</script>

<template>
  <video controls>
    <source :src="url" />
  </video>
</template>

<style scoped>
video {
  width: 100%;
}
</style>
